import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>DFW Health Tech</title>
        <meta property="og:title" content="DFW Health Tech" />
        <link
          rel="canonical"
          href="https://dfwhealthtech.com/"
        />
      </Helmet>
      <Navigation></Navigation>
      <main className="dfw-page-wrapper">
        <section className="hero-section">
          <div className="hero-media-container">
            <img
              src="https://images.pexels.com/photos/9574541/pexels-photo-9574541.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Healthcare Technology Innovation in Dallas"
              className="hero-bg-image"
            />
            <div className="hero-overlay"></div>
          </div>
          <div className="hero-content-wrapper">
            <div className="hero-text-block">
              <h1 className="home-hero-title hero-title">
                The Pulse of Dallas-Fort Worth Health Tech
              </h1>
              <p className="home-hero-subtitle hero-subtitle">
                Aggregating intelligence on the companies, investors, and news
                driving North Texas healthcare innovation.
              </p>
            </div>
            <div className="hero-interactive-row">
              <div className="hero-search-container">
                <div className="search-input-group">
                  <div className="search-icon-box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="m21 21l-4.34-4.34"></path>
                        <circle cx="11" cy="11" r="8"></circle>
                      </g>
                    </svg>
                  </div>
                  <input
                    type="text"
                    placeholder="Search companies, investors, or news..."
                    className="search-input"
                  />
                  <button className="btn btn-sm btn-primary">Search</button>
                </div>
              </div>
              <div className="hero-newsletter-compact">
                <form
                  action="/subscribe"
                  method="POST"
                  data-form-id="e876f1a0-fe59-4c5e-b458-ca1eb5ac54ef"
                  className="newsletter-form-compact"
                >
                  <div className="form-input-box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                        <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                      </g>
                    </svg>
                    <input
                      type="email"
                      placeholder="Weekly funding alerts"
                      required="true"
                      id="thq_textinput_zkfl"
                      name="textinput"
                      data-form-field-id="thq_textinput_zkfl"
                      className="newsletter-input"
                    />
                  </div>
                  <button
                    type="submit"
                    id="thq_button_P0Md"
                    name="button"
                    data-form-field-id="thq_button_P0Md"
                    className="btn btn-sm btn-accent"
                  >
                    Subscribe
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
        <section className="featured-rail-section">
          <div className="section-header-row">
            <div className="header-text">
              <h2 className="section-title">Featured Companies</h2>
              <p className="section-subtitle">
                Leading innovation in the DFW healthcare ecosystem
              </p>
            </div>
            <a href="/directory">
              <div className="btn btn-outline btn-sm">
                <span>View Directory</span>
              </div>
            </a>
          </div>
          <div className="card-rail-container">
            <div className="card-rail-track">
              <article className="company-card">
                <div className="card-badge">
                  <span>Featured</span>
                </div>
                <div className="company-info">
                  <h3 className="company-name">BioNorth Texas</h3>
                  <span className="sector-tag">Life Sciences</span>
                  <p className="company-desc">
                    Accelerating the commercialization of biotech innovations
                    across the region.
                  </p>
                </div>
                <a href="/profile/bionorth">
                  <div className="btn btn-sm btn-link">
                    <span>Full Profile</span>
                  </div>
                </a>
              </article>
              <article className="company-card">
                <div className="card-badge">
                  <span>Sponsored</span>
                </div>
                <div className="company-info">
                  <h3 className="company-name">HealthWildcatters</h3>
                  <span className="sector-tag">Accelerator</span>
                  <p className="company-desc">
                    Top-ranked healthcare seed accelerator based in Downtown
                    Dallas.
                  </p>
                </div>
                <a href="/profile/healthwildcatters">
                  <div className="btn btn-sm btn-link">
                    <span>Full Profile</span>
                  </div>
                </a>
              </article>
              <article className="company-card">
                <div className="company-info">
                  <h3 className="company-name">Caris Life Sciences</h3>
                  <span className="sector-tag">Diagnostics</span>
                  <p className="company-desc">
                    Pioneering precision medicine through AI-driven molecular
                    profiling.
                  </p>
                </div>
                <a href="/profile/caris">
                  <div className="btn btn-sm btn-link">
                    <span>Full Profile</span>
                  </div>
                </a>
              </article>
              <article className="company-card">
                <div className="company-info">
                  <h3 className="company-name">Teladoc Health</h3>
                  <span className="sector-tag">Telemedicine</span>
                  <p className="company-desc">
                    Global leader in whole-person virtual care, headquartered in
                    Lewisville.
                  </p>
                </div>
                <a href="/profile/teladoc">
                  <div className="btn btn-sm btn-link">
                    <span>Full Profile</span>
                  </div>
                </a>
              </article>
              <article className="company-card">
                <div className="company-info">
                  <h3 className="company-name">Signify Health</h3>
                  <span className="sector-tag">Value-Based Care</span>
                  <p className="company-desc">
                    Using technology and data to activate the best care in the
                    home.
                  </p>
                </div>
                <a href="/profile/signify">
                  <div className="btn btn-sm btn-link">
                    <span>Full Profile</span>
                  </div>
                </a>
              </article>
            </div>
          </div>
        </section>
        <section className="updates-rail-section">
          <div className="section-header-row">
            <div className="header-text">
              <h2 className="section-title">Latest Intelligence</h2>
              <p className="section-subtitle">
                Recent funding rounds and newsroom highlights
              </p>
            </div>
            <div className="filter-pills">
              <button className="pill active">All</button>
              <button className="pill">Funding</button>
              <button className="pill">M&amp;A</button>
            </div>
          </div>
          <div className="card-rail-container">
            <div className="card-rail-track">
              <article className="update-card">
                <div className="update-header">
                  <span className="update-type type-funding">Funding</span>
                  <time>2h ago</time>
                </div>
                <h3 className="update-title">
                  MedTech AI secures $12M Series A for surgical robotics
                </h3>
                <p className="update-snippet">
                  Led by DFW Capital Partners with participation from local
                  angel syndicates.
                </p>
                <a href="#">
                  <div className="btn btn-sm btn-link">
                    <span>Read More</span>
                  </div>
                </a>
              </article>
              <article className="update-card">
                <div className="update-header">
                  <span className="update-type type-ma">M&amp;A</span>
                  <time>1d ago</time>
                </div>
                <h3 className="update-title">
                  UT Southwestern partners with Amazon for Cloud Research
                </h3>
                <p className="update-snippet">
                  New collaboration aims to accelerate genomic data processing
                  in North Texas.
                </p>
                <a href="#">
                  <div className="btn btn-sm btn-link">
                    <span>Read More</span>
                  </div>
                </a>
              </article>
              <article className="update-card">
                <div className="update-header">
                  <span className="update-type type-launch">Product</span>
                  <time>3d ago</time>
                </div>
                <h3 className="update-title">
                  Plano-based startup launches remote patient monitoring kit
                </h3>
                <p className="update-snippet">
                  FDA clearance granted for new cardiac monitoring device for
                  home use.
                </p>
                <a href="#">
                  <div className="btn btn-sm btn-link">
                    <span>Read More</span>
                  </div>
                </a>
              </article>
              <article className="update-card">
                <div className="update-header">
                  <span className="update-type type-funding">Funding</span>
                  <time>5d ago</time>
                </div>
                <h3 className="update-title">
                  BioTech Solutions raises $45M for clinical trials
                </h3>
                <p className="update-snippet">
                  Largest biotech funding round in DFW this quarter, targeting
                  oncology.
                </p>
                <a href="#">
                  <div className="btn btn-sm btn-link">
                    <span>Read More</span>
                  </div>
                </a>
              </article>
            </div>
          </div>
        </section>
        <section className="resources-grid-section">
          <div className="container-inner">
            <div className="section-intro">
              <h2 className="section-title">Explore the Ecosystem</h2>
              <p className="section-subtitle">
                Deep dive into the specialized directories of North Texas
              </p>
            </div>
            <div className="resources-grid">
              <div className="resource-card">
                <div className="resource-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2"></path>
                      <path d="M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16"></path>
                      <path d="M10 12h4m-4-4h4m0 13v-3a2 2 0 0 0-4 0v3"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="resource-name">Company Directory</h3>
                <p className="resource-stat">450+ Companies</p>
                <p className="resource-detail">
                  Digital Health, MedTech, Pharma
                </p>
              </div>
              <div className="resource-card">
                <div className="resource-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M16 7h6v6"></path>
                      <path d="m22 7l-8.5 8.5l-5-5L2 17"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="resource-name">Investors</h3>
                <p className="resource-stat">85 Active VCs</p>
                <p className="resource-detail">Seed to Growth Stage funding</p>
              </div>
              <div className="resource-card">
                <div className="resource-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.4 22.4 0 0 1-4 2"></path>
                      <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0m1 7v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="resource-name">Accelerators</h3>
                <p className="resource-stat">12 Programs</p>
                <p className="resource-detail">Mentorship &amp; Seed Capital</p>
              </div>
              <div className="resource-card">
                <div className="resource-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M15 18h-5m8-4h-8m-6 8h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0v-9a2 2 0 0 1 2-2h2"></path>
                      <rect width="8" height="4" x="10" y="6" rx="1"></rect>
                    </g>
                  </svg>
                </div>
                <h3 className="resource-name">Market Maps</h3>
                <p className="resource-stat">Premium Reports</p>
                <p className="resource-detail">Bi-annual Sector Breakdowns</p>
              </div>
              <div className="resource-card">
                <div className="resource-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <circle cx="10" cy="7" r="4"></circle>
                      <path d="M10.3 15H7a4 4 0 0 0-4 4v2"></path>
                      <circle cx="17" cy="17" r="3"></circle>
                      <path d="m21 21l-1.9-1.9"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="resource-name">Talent Portal</h3>
                <p className="resource-stat">200+ Open Roles</p>
                <p className="resource-detail">Hire in North Texas</p>
              </div>
              <div className="resource-card">
                <div className="resource-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                      <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                    </g>
                  </svg>
                </div>
                <h3 className="resource-name">Submit Profile</h3>
                <p className="resource-stat">Free Listing</p>
                <p className="resource-detail">Join the Hub today</p>
              </div>
            </div>
          </div>
        </section>
        <section className="stats-grid-section">
          <div className="container-inner">
            <div className="section-intro">
              <h2 className="section-title">Market Vitality</h2>
              <p className="section-subtitle">
                Real-time indicators of the DFW health tech economy
              </p>
            </div>
            <div className="stats-grid">
              <div className="stat-item">
                <span className="stat-value">$1.2B</span>
                <span className="stat-label">Funding (YTD)</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">482</span>
                <span className="stat-label">Active Companies</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">15</span>
                <span className="stat-label">Exits this Year</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">Digital Health</span>
                <span className="stat-label">Top Sector</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">92</span>
                <span className="stat-label">Local Investors</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">+14%</span>
                <span className="stat-label">Annual Growth</span>
              </div>
            </div>
          </div>
        </section>
        <section className="timeline-section">
          <div className="container-inner">
            <div className="section-intro">
              <h2 className="section-title">Get Listed</h2>
              <p className="section-subtitle">
                Join the definitive directory for North Texas health innovation
              </p>
            </div>
            <div className="timeline-stepper">
              <div className="step-item">
                <div className="step-number">
                  <span>01</span>
                </div>
                <h3 className="step-title">Submit Details</h3>
                <p className="step-desc">
                  Fill out our comprehensive profile form with your company tags
                  and stage.
                </p>
              </div>
              <div className="step-item">
                <div className="step-number">
                  <span>02</span>
                </div>
                <h3 className="step-title">Admin Review</h3>
                <p className="step-desc">
                  Our analysts verify your data to ensure high-quality platform
                  intelligence.
                </p>
              </div>
              <div className="step-item">
                <div className="step-number">
                  <span>03</span>
                </div>
                <h3 className="step-title">Go Live</h3>
                <p className="step-desc">
                  Get featured in the directory and our weekly newsletter for
                  maximum visibility.
                </p>
              </div>
            </div>
            <div className="timeline-cta">
              <button className="btn btn-primary btn-lg">
                Submit Your Company
              </button>
            </div>
          </div>
        </section>
        <section className="final-cta-section">
          <div className="cta-inner-wrapper">
            <div className="cta-content">
              <h2 className="home-hero-title hero-title">
                Stay Ahead of the Curve
              </h2>
              <p className="home-hero-subtitle hero-subtitle">
                Join 5,000+ industry leaders receiving our weekly market
                intelligence briefing.
              </p>
              <div className="cta-form-container">
                <form
                  action="/subscribe"
                  method="POST"
                  data-form-id="a393dd2e-84e3-4baa-a080-95e486bb6dc5"
                  className="cta-form"
                >
                  <input
                    type="email"
                    placeholder="Enter your business email"
                    required="true"
                    id="thq_textinput_sFAT"
                    name="textinput"
                    data-form-field-id="thq_textinput_sFAT"
                    className="cta-input"
                  />
                  <button
                    type="submit"
                    id="thq_button_49mj"
                    name="button"
                    data-form-field-id="thq_button_49mj"
                    className="btn btn-lg btn-accent"
                  >
                    Join the Newsletter
                  </button>
                </form>
                <p className="cta-social-proof">
                  <span>
                    &quot;The most essential read for anyone in DFW
                    healthcare.&quot; —
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>VC Partner, Dallas</span>
                </p>
              </div>
              <div className="cta-highlights">
                <div className="highlight-pill">
                  <span>Latest Funding</span>
                </div>
                <div className="highlight-pill">
                  <span>M&amp;A Alerts</span>
                </div>
                <div className="highlight-pill">
                  <span>Job Openings</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<script defer data-name="dfw-health-tech-logic">
(function(){
  // Simple filter logic for updates rail
  const filterPills = document.querySelectorAll('.filter-pills .pill');
  const updateCards = document.querySelectorAll('.update-card');

  filterPills.forEach(pill => {
    pill.addEventListener('click', () => {
      // Remove active class from all
      filterPills.forEach(p => p.classList.remove('active'));
      pill.classList.add('active');

      const filterType = pill.textContent.toLowerCase();
      
      updateCards.forEach(card => {
        const typeLabel = card.querySelector('.update-type').textContent.toLowerCase();
        if (filterType === 'all' || typeLabel === filterType) {
          card.style.display = 'flex';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });

  // Search input interaction
  const searchInput = document.querySelector('.search-input');
  searchInput.addEventListener('focus', () => {
    document.querySelector('.hero-search-container').style.boxShadow = '0 20px 60px rgba(11, 99, 181, 0.3)';
  });
  
  searchInput.addEventListener('blur', () => {
    document.querySelector('.hero-search-container').style.boxShadow = '0 20px 40px rgba(0,0,0,0.3)';
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Home
